import React from 'react';
import { useRouter } from 'next/router';
import Link from '../../../Link';
import { categoryColor } from '../shared';
import { toTitleCase } from '~/utils/stringUtils';
import { ArrowIcon } from '../ArticleSnippet';

interface TagsListProps {
  tags: string[];
}

export function TagsList({ tags }: TagsListProps) {
  const router = useRouter();
  const pathToUse = router.asPath;
  const pathSlugs = pathToUse.split('/').filter((slug) => slug !== '');
  const basePath = `/${pathSlugs.shift()}`;

  return tags.length === 0 ? null : (
    <div
      className="flex flex-wrap gap-2 desktop:mt-6"
      data-testid="blog-tags-list"
    >
      {tags.map((tag, index) => {
        // For the first tab (article category) we link to its page, for other tags we navigate to base path
        const path = (
          index == 0 ? basePath + `/${tag.toLowerCase()}` : basePath
        ).replaceAll(' ', '-');

        // Convert category name to slug format for consistent color mapping
        const categorySlug = tag
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '');

        return (
          <span
            key={tag}
            className="group/button typography-body-2 relative flex w-fit items-center rounded-full px-[6px] py-[2px] font-medium leading-4"
            style={{
              background:
                categoryColor[categorySlug] || categoryColor['popular']
            }}
          >
            <Link href={path}>{toTitleCase(tag)}</Link>
            <ArrowIcon className="ml-1 hidden transition-all duration-300 group-hover/button:block" />
          </span>
        );
      })}
    </div>
  );
}
